import { useMemo, memo } from 'react';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const youtubeLocal = {
    jp: 'https://www.youtube.com/embed/CfIZJdRv-eg?si=G26GwZnzXBChj_yp',
} as const;

function TheComp() {
    const { t } = useLang('theProduct.BannerA');

    const dataA: EcoBannerProps = useMemo(
        () => ({
            layout: 'top-center' as const,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761297608568/road_kv.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761297608428/road_kv_h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761297608428/road_kv_h5.jpg',
            title: t('BannerA_title'),
            desc: t('BannerA_desc'),
            descColor: '#3A3C3F',
            rHref: youtubeLocal['jp'],
            rChildren: (
                <EcoLink
                    data-btn-id={`youtube-btn`}
                    className="GtmModuleData-btn-common"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'video',
                        title_name: t('BannerA_btn'),
                        position: 'Product Detail_1',
                        __btn_id1: `RV-firstKV .eco-banner-card-btn-youtube`,
                        __btn_id2: `youtube-btn`,
                        __btn_type: 'common',
                    }}
                >
                    {t('BannerA_btn')}
                </EcoLink>
            ),
            rBtnIsYouToBe: true,
        }),
        [t],
    );

    return (
        <div className={`${styles.FirstKV} RV-firstKV rv-jp-first-kv`}>
            <EcoBanner {...dataA} />
        </div>
    );
}

export default memo(TheComp);
